export default __webpack_public_path__ + "static/week5-234ed3a5b0068d87a24d6af6aea9b8cc.png";